export function isVolumeLoading(imageVolume) {
    return (imageVolume?.loadStatus
        ?.loading === true);
}
export function isSegmentationOverlayData(payload, options) {
    return (options?.role === 'overlay' && payload.reference?.kind === 'segmentation');
}
export function readBoundQuality(imageVolume, boundGrid) {
    return boundGrid
        ? imageVolume.getGridQuality(boundGrid.grid, boundGrid.statistic)
        : imageVolume.getVoxelQuality();
}
